import React, { useState } from "react";
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyAEnlbl76bWSyhNPmPkfoXToB9kY4ADZPs",
  authDomain: "auto-a60e4.firebaseapp.com",
  projectId: "auto-a60e4",
  storageBucket: "auto-a60e4.firebasestorage.app",
  messagingSenderId: "74186188333",
  appId: "1:74186188333:web:319f812daf4eb409ae7aa4",
  measurementId: "G-4MK4HY9JQM"
};

const app = initializeApp(firebaseConfig);
const storage = getStorage(app);

export default function VideoUploader() {
  const [file, setFile] = useState(null);
  const [progress, setProgress] = useState(0);
  const [url, setUrl] = useState("");

  const handleUpload = () => {
    if (!file) return;

    const storageRef = ref(storage, `videos/${Date.now()}_${file.name}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const p = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setProgress(Math.floor(p));
      },
      (error) => {
        alert("Erreur d'upload : " + error.message);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setUrl(downloadURL);
        });
      }
    );
  };

  return (
    <div className="container p-4 border rounded shadow">
      <h4>Uploader une vidéo vers Firebase</h4>
      <input
        type="file"
        accept="video/mp4"
        onChange={(e) => setFile(e.target.files[0])}
        className="form-control mb-2"
      />
      <button className="btn btn-primary" onClick={handleUpload} disabled={!file}>
        Upload
      </button>
      {progress > 0 && <p>Progression : {progress}%</p>}
      {url && (
        <div>
          <p className="mt-3">✅ URL publique :</p>
          <code style={{ wordBreak: "break-all" }}>{url}</code>
          <video
            src={url}
            controls
            autoPlay
            muted
            loop
            style={{ width: "100%", marginTop: "10px" }}
          />
        </div>
      )}
    </div>
  );
}
